module.exports = __webpack_public_path__ + "7e74b76b7ec003b3f91a51075624922e.svg";